import { Box, CircularProgress } from "@mui/material";

const LoadingSpinner = () => {
  return (
    <Box
      data-testid="layout-loader"
      sx={{
        display: "flex",
        flex: 1,
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress
        sx={{
          fill: "#3BD6FF",
        }}
      />
    </Box>
  );
};

export default LoadingSpinner;
